module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header'), _vm._v(" "), _c('router-view', {
    staticClass: "main"
  }), _vm._v(" "), _c('m-footer'), _vm._v(" "), _c('transition', {
    on: {
      "after-enter": _vm.afterEnter,
      "before-enter": _vm.beforeEnter
    }
  }, [(_vm.cart.showMoveImg) ? _c('div', {
    staticClass: "move_img",
    style: ({
      left: (_vm.cart.cartPositionL - 20) + 'px',
      top: (_vm.cart.cartPositionT - 15) + 'px'
    })
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.cart.moveImgUrl
    }
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75845ece","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = 668
// module chunks = 0